import data from "../../../../../packages/react/src/Avatar/Avatar.docs.json";
import { Avatar, Box } from '@primer/react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  Avatar,
  Box,
  DeprecationBanner,
  React
};